import { render } from "./UiRadioCards.vue?vue&type=template&id=e49aac22"
import script from "./UiRadioCards.vue?vue&type=script&lang=js"
export * from "./UiRadioCards.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__